module.exports = __webpack_public_path__ + "img/explosive.satchel.1a4b5a08.png";